import BaseApi  from './BaseApi'

class UserService extends BaseApi {
  async login(email, password) {
    const path = '/token/'
    const data = {username: email, password: password}
    return this.doRequest('post', path, data)
  }

  async register({firstName, lastName, email, password, profile, termsAccepted}) {
    const path = '/v1/users/'
    const data = {
      first_name: firstName,
      last_name: lastName,
      email,
      password,
      terms_accepted: termsAccepted,
      profile: {
        sex: profile.sex,
        profile_type: profile.profileType
      }
    }

    return this.doRequest('post', path, data);
  }

  async getUserData() {
    const path = '/v1/users/'
    const response = await this.axios.get(path)
    if (response.data.length) {
      return response.data[0]
    }
    return {}
  }

  async getUsers(query) {
    let path = '/v1/public/users/'
    if (query) {
      path = `${path}?query=${query}`
    }
    const response = await this.axios.get(path)
    return response.data
  }

  async updateName(userId, { firstName, lastName }) {
    const path = `/v1/users/${userId}/`
    return this.doRequest('patch', path, {
      first_name: firstName,
      last_name: lastName
    })
  }

  async changePassword(userId, { currentPassword, newPassword }) {
    const path = `/v1/users/${userId}/change_password/`
    return this.doRequest('post', path, {
      current_password: currentPassword,
      new_password: newPassword
    })
  }
}

export default UserService
